import QuizBanner from './QuizBanner';

export default function QuizBannerWide() {
  return <QuizBanner variant="wide" />;
}
